import { Box, Checkbox, FormControlLabel, Switch, Typography } from "@mui/material";
import React from "react";

const daysOfWeek = [
	"Monday",
	"Tuesday",
	"Wednesday",
	"Thursday",
	"Friday",
	"Saturday",
	"Sunday",
];

const MinWeekHoursNotifSettings = ({
	newShiftSettings,
	setNewShiftSettings,
}: any) => {
	if (Object.keys(newShiftSettings).length === 0) return null;

	const handleDayToggle = (day: string) => {
		let currentDays = newShiftSettings.minWeekHoursNotifTriggerDays || [];
		if (typeof currentDays === "string") {
			try {
				currentDays = JSON.parse(currentDays);
			} catch (e) {
				currentDays = currentDays.split(",").map((s: string) => s.trim()).filter(Boolean);
			}
		}

		if (Array.isArray(currentDays)) {
			currentDays = currentDays.filter((d: any) => daysOfWeek.includes(d));
		} else {
			currentDays = [];
		}

		const nextDays = currentDays.includes(day)
			? currentDays.filter((d: string) => d !== day)
			: [...currentDays, day];
		
		setNewShiftSettings((prev: any) => ({
			...prev,
			minWeekHoursNotifTriggerDays: nextDays,
		}));
	};

	return (
		<Box
			sx={{
				backgroundColor: "#F5F5F5",
				borderRadius: "8px",
				padding: "16px",
				marginTop: "32px",
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
					}}
				>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "16px",
							color: "rgba(0, 0, 0, 0.87)",
						}}
					>
						Minimum Weekly Hours Notification
					</Typography>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 400,
							fontSize: "12px",
							color: "rgba(0, 0, 0, 0.6)",
						}}
					>
						Enable notifications when workers have not met their minimum weekly hours.
					</Typography>
				</Box>
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<Switch
						checked={newShiftSettings.minWeekHoursNotifEnabled ?? false}
						onChange={(e) =>
							setNewShiftSettings((prevSettings: any) => ({
								...prevSettings,
								minWeekHoursNotifEnabled: e.target.checked,
							}))
						}
					/>
				</Box>
			</Box>
			{newShiftSettings.minWeekHoursNotifEnabled && (
				<Box sx={{ mt: 2 }}>
					<Typography
						sx={{
							fontFamily: "Roboto",
							fontWeight: 500,
							fontSize: "14px",
							color: "rgba(0, 0, 0, 0.87)",
							mb: 1,
						}}
					>
						Trigger Days
					</Typography>
					<Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
						{daysOfWeek.map((day) => (
							<FormControlLabel
								key={day}
								control={
									<Checkbox
										size="small"
										checked={(newShiftSettings.minWeekHoursNotifTriggerDays || []).includes(day)}
										onChange={() => handleDayToggle(day)}
									/>
								}
								label={<Typography sx={{ fontSize: "14px" }}>{day}</Typography>}
							/>
						))}
					</Box>
				</Box>
			)}
		</Box>
	);
};

export default MinWeekHoursNotifSettings;
